module.exports = __webpack_public_path__ + "static/media/alison-brie-icon.8e37b407.jpg";